module.exports = __webpack_public_path__ + "static/media/icon_T4.00f24478.svg";